import React from "react";

// @material-ui/core components
import Box from "@material-ui/core/Box";
import FooterLinks from "./FooterLinks";

const Footer = () => {
  return (
    <Box component="footer" marginX={"1rem"}>
      <FooterLinks/>
    </Box>
  );
};

export default Footer;
